/**
 * Basketball Cart Animation
 * Intercepts fly-to-cart elements and makes them look like a basketball.
 * Triggers a net-swish animation on the cart icon (hoop) when the ball lands.
 */

const BASKETBALL_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32">
  <circle cx="16" cy="16" r="15" fill="#e8621a"/>
  <circle cx="16" cy="16" r="15" fill="none" stroke="#c2501a" stroke-width="0.5"/>
  <path d="M1 16 h30" stroke="#3a1800" stroke-width="1.5" opacity="0.4" fill="none"/>
  <path d="M16 1 Q7 16 16 31 Q25 16 16 1" stroke="#3a1800" stroke-width="1.5" fill="none" opacity="0.4"/>
  <path d="M1 9 Q16 14 31 9" stroke="#3a1800" stroke-width="1.5" fill="none" opacity="0.4"/>
  <path d="M1 23 Q16 18 31 23" stroke="#3a1800" stroke-width="1.5" fill="none" opacity="0.4"/>
</svg>`;

function triggerHoopSwish() {
  const cartIcon = document.querySelector('cart-icon');
  if (!cartIcon) return;
  cartIcon.classList.remove('hoop-swish');
  // Force reflow so animation restarts if rapid-fired
  void cartIcon.offsetWidth;
  cartIcon.classList.add('hoop-swish');
  cartIcon.addEventListener('animationend', () => {
    cartIcon.classList.remove('hoop-swish');
  }, { once: true });
}

function makeBasketball(node) {
  // Override styling to look like a basketball
  node.style.setProperty('background-image', 'none', 'important');
  node.style.setProperty('background-color', 'transparent', 'important');
  node.style.setProperty('border-radius', '50%', 'important');
  node.style.setProperty('width', '32px', 'important');
  node.style.setProperty('height', '32px', 'important');
  node.innerHTML = BASKETBALL_SVG;

  // Trigger net swish on first animationend (three run simultaneously)
  let scored = false;
  node.addEventListener('animationend', () => {
    if (scored) return;
    scored = true;
    triggerHoopSwish();
  });
}

// Watch for fly-to-cart elements being added to the DOM
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.tagName === 'FLY-TO-CART') {
        makeBasketball(node);
      }
    }
  }
});

observer.observe(document.body, { childList: true });
